import request from './request'

// 系统公告模块
// 对应后端：/api/v1/admin/sysNotice/*（表 sys_notice 公告/通知）

// 公告分页查询
// 方法+URL：POST /api/v1/admin/sysNotice/page
// 对应后端 Controller/表：SysNoticeController / sys_notice
// 入参 params：分页与筛选条件
// 返回：分页数据 { records, total }
export function sysNoticePage(params) {
  return request({ url: '/api/v1/admin/sysNotice/page', method: 'post', data: params })
}

// 公告列表查询（不分页）
// 方法+URL：GET /api/v1/admin/sysNotice/list
// 对应后端 Controller/表：SysNoticeController / sys_notice
// 入参：无
// 返回：sys_notice 实体数组
export function sysNoticeList() {
  return request({ url: '/api/v1/admin/sysNotice/list', method: 'get' })
}

// 公告详情
// 方法+URL：GET /api/v1/admin/sysNotice/{id}
// 对应后端 Controller/表：SysNoticeController / sys_notice
// 入参 id：公告主键
// 返回：单条公告记录
export function sysNoticeGet(id) {
  return request({ url: '/api/v1/admin/sysNotice/' + id, method: 'get' })
}

// 新增/修改公告
// 方法+URL：POST /api/v1/admin/sysNotice（新增） / PUT /api/v1/admin/sysNotice（修改）
// 入参：SysNotice 实体 JSON（含 id 则修改，不含则新增）
export function sysNoticeSave(data) {
  if (data.id) {
    return request({ url: '/api/v1/admin/sysNotice', method: 'put', data })
  }
  return request({ url: '/api/v1/admin/sysNotice', method: 'post', data })
}

// 删除公告（软删除）
// 方法+URL：DELETE /api/v1/admin/sysNotice/{id}
export function sysNoticeDelete(id) {
  return request({ url: '/api/v1/admin/sysNotice/' + id, method: 'delete' })
}
